import Vue from 'vue';

export default () => {
  Vue.filter('DefaultStringIfNull', (value) => {
    if (!value) return 'N/A';
    return value;
  });
  Vue.filter('DefaultToZero', (value) => {
    if (!value) return '0';
    return value;
  });
  Vue.filter('toPercent', (value) => {
    if (!value) return 'N/A';
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
    return formatter.format(value);
  });
  Vue.filter('toCurrency', (value) => {
    if (typeof value !== 'number') {
      return value;
    }
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    });
    return formatter.format(value);
  });
};
